import styled, { css } from 'styled-components';
import { TextButton as Button } from '../../../../design-system';
import { COLORS } from '../../../styles/variables';
import { AlphaTheme } from '../../../../design-system/ThemeProvider/alphaTheme';

export const ZipInputWrapper = styled.form`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 24px 0px 16px 24px;
  gap: 16px;
`;
export const InputComponent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 245px;
`;
export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.canvas200
      ? css`
          border-radius: ${theme.borderRadiusMax ?? '999px'};
          border: 1px solid ${theme.formFieldStroke};
          background: ${theme.formFieldFill};
          padding: 12px ${theme.spaceFixed200 ?? '16px'};
          gap: 8px;
        `
      : css`
          border-bottom: 1px solid ${COLORS.grey80};
          padding-bottom: 8px;
        `}
`;
export const Description = styled.div`
  padding-top: 12px;
  padding-left: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.spaceFixed200 ?? '16px'};
  padding-right: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.spaceFixed200 ?? '16px'};
  letter-spacing: 0.002px;
  line-height: 20px;
  font-size: 12px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral200 ?? COLORS.grey60};
`;
export const TextInputField = styled.input`
  width: 100% !important;
  all: unset;
  position: relative;
  height: 24px;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  outline: none;
  box-sizing: unset !important;
  padding-right: ${({ theme }: { theme: Partial<AlphaTheme> }) => (theme.canvas200 ? '44px' : '0')};
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral100 ?? 'inherit'};

  &::placeholder {
    color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
      theme.foregroundNeutral200 ?? COLORS.grey60};
  }

  :-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  }
  :-moz-placeholder {
    color: transparent !important;
  }
  :-moz-placeholder:focus {
    color: #555 !important;
  }
`;

export const BackToNationalWrapper = styled.div`
  padding-top: 12px;
  a,
  button {
    text-decoration: none;
  }
`;

export const BackToNational = styled.button`
  background-color: inherit;
  padding: 0;
  padding-top: 12px;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  letter-spacing: 0.002px;
  line-height: 20px;
  font-size: 12px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral200 ?? COLORS.grey60};
  cursor: pointer;
`;

export const DeleteInputIcon = styled.button`
  padding: 0;
  background-color: transparent;
  border: none;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.canvas200
      ? (theme.foregroundOnFormfieldsSubdued ?? 'inherit')
      : (theme.foregroundNeutral100 ?? 'inherit')};
  position: absolute;
  right: ${({ theme }: { theme: Partial<AlphaTheme> }) => (theme.canvas200 ? '16px' : '0')};
  padding-left: ${({ theme }: { theme: Partial<AlphaTheme> }) => (theme.canvas200 ? '12px' : '0')};
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const SubmitLinkWrapper = styled.div`
  white-space: nowrap;
  a,
  button,
  span {
    text-decoration: none !important;
  }
`;

export const StyledCTA = styled(Button)`
  width: auto;
  min-width: fit-content;
  span {
    font-stretch: unset;
  }
`;
